import { Constants } from "appConstants";
import { IcoPlus, IcoTrash } from "assets/icons";
import { Button, Input, Select } from "components";
import { useState } from "react";
import "./styles.scss";
import {
	DynamicSelectTextInputGroupProps,
	FieldProps,
	OptionProps
} from "./types";

export default function DynamicSelectTextInputGroup({
	name,
	addFieldLabel = Constants.strings.fields.addNewLink,
	isRequired = false,
	labelSelect,
	labelInput,
	minFields = 1,
	maxFields,
	placeholders,
	initialFields,
	options,
	values,
	errors,
	touched,
	defaultEmptyValue = "",
	setFieldValue,
	onBlur
}: DynamicSelectTextInputGroupProps) {
	const minInitialFields = (): FieldProps[] => {
		if (minFields > 0) {
			const vetor: FieldProps[] = [];
			for (let i = 0; i < minFields; i += 1) {
				vetor.push({
					label: ``,
					value: "",
					text: defaultEmptyValue
				});
			}
			return vetor;
		}
		return [];
	};
	const [fields, setFields] = useState(initialFields || minInitialFields());
	const [amountOfFields, setAmountOfFields] = useState(minFields);

	const handleAddSelectTextInputField = () => {
		if (!maxFields || amountOfFields < maxFields) {
			setFields([
				...fields,
				{
					label: "",
					value: "initial",
					text: defaultEmptyValue
				}
			]);
			setAmountOfFields(amountOfFields + 1);
		}
	};

	const handleDeleteSelectTextInputField = (index: number) => {
		setFieldValue(`${fields[index]?.value}`, "");
		fields.splice(index, 1);
		setFields([...fields]);
		setAmountOfFields(amountOfFields - 1);
	};

	function handleChangeLinkType(newValue: OptionProps, index: number) {
		const oldField = fields[index];
		if (fields.length < index + 1) {
			const newArr = [...fields, { ...newValue, text: "" }];
			setFields(newArr);
		} else {
			fields[index] = { ...fields[index], ...newValue };
			setFields([...fields]);
		}

		setFieldValue(`${newValue.value}`, fields[index].text);
		setFieldValue(`${oldField.value}`, defaultEmptyValue);
	}

	const availableOptions = (index: number): OptionProps[] => {
		if (fields.length === 0) return options;
		const filteredOptions = options.filter(
			(option) => !fields.some((field) => field.value === option.value)
		);
		if (options.some((option) => option === fields[index]))
			filteredOptions.push(fields[index]);
		return filteredOptions;
	};

	return (
		<div className="flex flex-col align-center space-y-4">
			{fields.map(
				(item, index) =>
					index < amountOfFields && (
						<div className="flex items-start" key={`link-${index}`}>
							<Select
								key={`linkTypes-${index}`}
								name={`${name}.select.${
									fields.length > index ? fields[index]?.value : ""
								}`}
								label={labelSelect}
								placeholder="Selecione"
								options={availableOptions(index)}
								value={fields[index]}
								setFieldValue={(_, value) => {
									handleChangeLinkType(value, index);
								}}
								className="w-44 mr-6"
								onBlur={onBlur}
								isClearable={false}
								hideOptional
							/>
							<Input
								key={`dynamic-group-text-field-${name}-${index}`}
								name={`${fields[index]?.value}`}
								label={labelInput}
								placeholder={placeholders[fields[index]?.value] ?? ""}
								type="text"
								value={values?.[fields[index]?.value]}
								required={isRequired}
								className="w-[23rem] mr-2 dynamic-input"
								onChange={(e) => {
									setFieldValue(`${fields[index]?.value}`, e.target.value);
									fields[index] = {
										...fields[index],
										text: e.target.value
									};
									setFields([...fields]);
								}}
								onBlur={onBlur}
								error={errors ? errors[fields[index]?.value]?.toString() : ""}
								touched={touched ? !!touched[fields[index]?.value] : false}
							/>
							<Button
								kind="icon"
								styled="ghost"
								onClick={() => {
									handleDeleteSelectTextInputField(index);
								}}
								cssClass="mt-6"
							>
								<IcoTrash size="24" />
							</Button>
						</div>
					)
			)}
			{(!maxFields || amountOfFields < maxFields) && (
				<Button
					styled="secondary"
					onClick={handleAddSelectTextInputField}
					cssClass="w-[10.375rem] h-10 text-sm"
				>
					<IcoPlus color="#000000" size="16" />
					<p className="whitespace-nowrap text-sm">{addFieldLabel}</p>
				</Button>
			)}
		</div>
	);
}
